
// import $ from 'jquery'
import ListeAnalyse from '@/components/parametres/parametre/custom_exclusions/l-analyse'
import ListeExamen from '@/components/parametres/parametre/custom_exclusions/l-examen'
import ListeMedicament from '@/components/parametres/parametre/custom_exclusions/l-medicament'
import ListeConsommable from '@/components/parametres/parametre/custom_exclusions/l-consommable'
import ListeChirurgie from '@/components/parametres/parametre/custom_exclusions/l-chirurgie'
import ListeBilanSante from '@/components/parametres/parametre/custom_exclusions/l-bilan-sante'
import ListeActe from '@/components/parametres/parametre/custom_exclusions/l-acte'
import ListeTypeAdmission from '@/components/parametres/parametre/custom_exclusions/l-type-admission'
import store_config from '@/store/mods/parametres/config'

export default {
    name: 'manage-exclusion',
    components: {
        ListeAnalyse, ListeExamen, ListeMedicament,
		ListeConsommable, ListeChirurgie, ListeBilanSante,
		ListeActe, ListeTypeAdmission
    },
    props: {
		user_info: {
			type: Object,
			default: () => ''
		}
	},
    data() {
        return {
            type_prestations: [
                { type: 'analyse', libelle: 'Analyses', id: 1, },
				{ type: 'examen', libelle: 'Examens', id: 2, },
				{ type: 'medicament', libelle: 'Médicaments', id: 3, },
				{ type: 'consommable', libelle: 'Consommables', id: 4, },
				{ type: 'chirurgie', libelle: 'Chirurgies', id: 5, },
				{ type: 'bilan_sante', libelle: 'Bilan de santé', id: 6, },
				{ type: 'acte', libelle: 'Actes', id: 7, },
				{ type: 'chambre', libelle: 'Chambres', id: 8, },
				{ type: 'observation', libelle: 'Observations', id: 9, },
				{ type: 'admission', libelle: 'Admissions', id: 10, }
            ],
			selected_type_prestation: {
				type: 'analyse',
				libelle: 'Analyses',
				id: 1,
			},
            type_exclusion: 'analyse',

			save_loading: false,
			msg_err: '',
			selected_items: []
        }
    },

    computed: {

    },

    mounted() {

    },

    methods: {
        handleChangeTypePrestation() {
			this.type_exclusion = this.selected_type_prestation.type
		},

		getSelectedItems() {
            const refs = this.$refs
            switch (this.type_exclusion) {
                case 'analyse':
                    return refs.listeAnalyse?.one_is_checked || []
                case 'examen':
                    return refs.listeExamen?.one_is_checked || []
                case 'medicament':
                    return refs.listeMedicament?.one_is_checked || []
                case 'consommable':
                    return refs.listeConsommable?.one_is_checked || []
                case 'chirurgie':
                    return refs.listeChirurgie?.one_is_checked || []
                case 'bilan_sante':
                    return refs.listeBilanSante?.one_is_checked || []
                case 'acte':
                    return refs.listeActe?.one_is_checked || []
                case 'chambre':
                case 'observation':
                case 'admission':
                    return refs.listeTypeAdmission?.one_is_checked || []
                default:
                    return []
            }
        },

		save() {
            this.selected_items = this.getSelectedItems()

			const data = {
				exclusions: this.selected_items,
				data_type: this.type_exclusion,
				user_id: this.user_info.id,
				user: this.user_info.nom
			}
            
			
            this.save_loading = true
			store_config.saveCustomExclusion(data).then((response) => {
                if (response.success) {
                    this.$refs.mng_custom_exclusion.click()
                    this.successToast(response.message)

                    this.$emit("emitRefreshCustomExclusion")
                } else {
                    this.msg_err = response.message
                }
                this.save_loading = false
            }).catch(() => {
                this.save_loading = false
                this.msg_err = "Une erreur est survenue lors de l'enregistrement. Veuillez réessayer plus tard."
            })
		}
    }
}